import styled from 'styled-components';

// Flexbox
export const Flex = styled.div`
  display: flex;
  flex-direction: ${props => props.direction};
  flex-wrap: ${props => props.wrap};

  justify-content: ${props => props.justify};
  align-items: ${props => props.align};
`;

// CSS Grid
export const Grid = styled.div`
  display: grid;

  /* CSS Grid related props */
  grid-template-columns: ${props => props.columns};
  grid-template-rows: ${props => props.rows};
  grid-gap: ${props => props.gap};
`;

export const GridItem = styled.div`
  grid-column: ${props => props.column};
  grid-row: ${props => props.row};
`;
